import moment from 'moment'
import React, { FC } from 'react'
import { Transaction } from '../../@types/transaction'
import { format } from '../../helpers/number'
import { getTxTypeText } from '../../helpers/transaction'
import { Empty, Tag, Typography } from 'antd'

const { Text } = Typography

interface PromotionListItemProps {
	tx: Transaction
}
const PromotionListItem: FC<PromotionListItemProps> = ({ tx }) => (
	<div className="transaction-card" key={tx.id}>
		<div className="transaction-header">
			<Tag>{moment(tx.createdAt).format('DD/MM/YYYY HH:mm')}</Tag>
			<Tag color="blue">* ยอดเทิร์นที่ต้องทำ: {format(tx.totalTurn)}</Tag>
		</div>

		<div className="transaction-body">
			<div className="transaction-info">
				<div className="transaction-title">รับโบนัส</div>
				<Text>{tx.remark}</Text>
			</div>
			<div className="transaction-title">฿ {format(tx.amount)}</div>
		</div>
	</div>
)

interface OtherListProps {
	data: Transaction[]
}
const OtherList: FC<OtherListProps> = ({ data }) => {
	if (data.length <= 0) {
		return (
			<Empty
				description='คุณไม่มีรายการอื่น ๆ'
				image={Empty.PRESENTED_IMAGE_SIMPLE}
			/>
		)
	}

	return (
		<>
			{data.map((tx) => {
				if (tx.type === 'promotion') {
					return <PromotionListItem tx={tx} key={tx.id} />
				}
				return (
					<div className="transaction-card" key={tx.id}>
						<div className="transaction-header">
							<Tag>{moment(tx.createdAt).format('DD/MM/YYYY HH:mm')}</Tag>
						</div>

						<div className="transaction-body">
							<div className="transaction-info">
								<div className="transaction-title">{getTxTypeText(tx.type)}</div>
							</div>
							<div className="transaction-title">฿ {format(tx.amount)}</div>
						</div>
					</div>
				)
			})}
		</>
	)
}

export default OtherList
